import script from "./SddsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SddsHeader.vue?vue&type=script&setup=true&lang=js"

import "./SddsHeader.vue?vue&type=style&index=0&id=44c05798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44c05798"]])

export default __exports__